<template>
  <node-view-wrapper
    class="tooltip-block"
    :class="[`tooltip-${props.node.attrs.iconType}`]"
    :data-icon-type="props.node.attrs.iconType"
    :data-block-id="props.node.attrs.blockId"
  >
    <!-- Title line with icon and title -->
    <div class="tooltip-title-line">
      <img
        v-if="iconPath"
        :src="iconPath"
        :alt="`${props.node.attrs.iconType} icon`"
        class="tooltip-icon"
      />
      <node-view-content
        as="div"
        class="tooltip-title"
        data-content-type="tooltipTitle"
      />
    </div>

    <!-- Body content - transitions from hidden to visible -->
    <node-view-content
      as="div"
      class="tooltip-body"
      data-content-type="tooltipBody"
    />
  </node-view-wrapper>
</template>

<script setup>
import { NodeViewContent, nodeViewProps, NodeViewWrapper } from "@tiptap/vue-3";
import { computed, defineProps } from "vue";

const props = defineProps(nodeViewProps);

const iconPath = computed(() => {
  const getIconPath = props.extension.options.getIconPath;
  return getIconPath(props.node.attrs.iconType);
});
</script>

<style>
/* Tooltip accordion styles */
.tooltip-block {
  border: 1px solid #dbeafe; /* Light blue border */
  border-radius: 8px;
  margin: 1em 0;
  background-color: #eff6ff; /* Very light blue background */
  transition: all 0.2s ease;
}

.tooltip-title-line {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #eff6ff; /* Light blue background for title */
  gap: 10px;
  cursor: pointer;
  user-select: none;
}

.tooltip-icon {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  display: block; /* Remove extra space below img */
  flex-shrink: 0; /* Prevent shrinking */
}

/* Title div */
.tooltip-title {
  flex-grow: 1; /* Take remaining space */
  font-weight: 600; /* Bold title */
  color: var(--primary-blue, #2563eb); /* Use primary blue */
  line-height: 1.4;
  min-height: 24px; /* Minimum height even when empty */
}

/* Accordion arrow */
.accordion-arrow {
  color: var(--primary-blue, #2563eb);
  transition: transform 0.2s ease;
}

.accordion-arrow.is-open {
  transform: rotate(180deg);
}

/* Body content wrapper with transition */
.tooltip-body-wrapper {
  height: 0;
  overflow: hidden;
  transition: height 0.3s ease;
}

.tooltip-body-wrapper.is-open {
  height: auto;
  border-top: 1px solid #dbeafe; /* Separator line */
}

/* Body content */
.tooltip-body {
  padding: 10px 12px;
  background-color: #ffffff; /* White background for body */
  color: #374151; /* Darker gray text */
  font-size: 0.95em;
  line-height: 1.6;
}

/* Ensure paragraphs inside body have normal spacing */
.tooltip-body p {
  margin-bottom: 0.5em;
}
.tooltip-body p:last-child {
  margin-bottom: 0;
}

/* When the tooltip is open */
.tooltip-block.is-open {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}
</style>
